import dayjs from 'dayjs'
import { TFunction } from 'i18next'
import { formatScheduledHour } from './scheduledTriggerConfigUtils'

export interface ScheduledTriggerSummaryConfig {
  frequency: string
  hour: number
  minute: number
  day_of_week?: number | null
  day_of_month?: number | null
}

export const buildScheduledTriggerSummary = (
  t: TFunction,
  config: ScheduledTriggerSummaryConfig
): string =>
  t(`workflows.config.schedule.summary.${config.frequency}`, {
    frequency: t(`workflows.config.schedule.frequency.${config.frequency}`),
    weekday: t(`workflows.config.schedule.weekday.${config.day_of_week ?? 1}`),
    day: t(`workflows.config.schedule.day.${config.day_of_month ?? 1}`),
    time: formatScheduledHour(config.hour)
  })

export const formatScheduledRunDate = (t: TFunction, isoDate: string): string => {
  const date = dayjs(isoDate)
  return t('workflows.config.schedule.nextRuns.item', {
    date: date.format('dd D.M.YYYY'),
    time: date.format('HH:mm')
  })
}
